import { createStore, applyMiddleware, compose, Store } from 'redux';
import { thunk } from 'redux-thunk';
import { FixMeLater } from '../temporary-types';
import rootReducer, { RootStore } from './reducers';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store: Store<RootStore, FixMeLater> & {
  dispatch: FixMeLater;
} = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
/* eslint-enable */

export default store;
